import { type FragmentOf, graphql, readFragment } from "@/graphql"

const graphQLFragments = {
    agreement: graphql(`
        fragment isAgreementElectricity_Agreement on AgreementType {
            __typename
        }
    `),
}

type IsAgreementElectricityProps = {
    agreement: FragmentOf<typeof graphQLFragments.agreement>
}

export function isAgreementElectricity(props: IsAgreementElectricityProps) {
    const agreement = readFragment(graphQLFragments.agreement, props.agreement)

    return agreement.__typename === "ElectricitySpecificAgreementType"
}

isAgreementElectricity.fragments = graphQLFragments
